var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIconBgBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fb-icon-Bg--black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-5",
    transform: "translate(-180.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb-icon-Bg--black",
    transform: "translate(180.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fillOpacity: 0.475897516,
    fill: "#000000",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "fb-icon--brown.fbda7af8775c2a3196af2caac36e1d4d",
    transform: "translate(8.000000, 5.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.98973802,12 L3.98973802,5.99929743 L5.76476994,5.99929743 L6,3.93142209 L3.98973802,3.93142209 L3.99275377,2.89643058 C3.99275377,2.35709687 4.04766594,2.06810953 4.87775659,2.06810953 L5.98743429,2.06810953 L5.98743429,0 L4.21215106,0 C2.07975039,0 1.32920062,1.00314201 1.32920062,2.69011144 L1.32920062,3.93165629 L0,3.93165629 L0,5.99953162 L1.32920062,5.99953162 L1.32920062,12 L3.98973802,12 Z",
    id: "Shape-Copy-15"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIconBgBlack);
export default __webpack_public_path__ + "static/media/fb-icon-Bg--black.158b7aab03935e47462ec4fa80ea8ff7.svg";
export { ForwardRef as ReactComponent };